import React from "react";
import "../styles/style.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroWoods from "../components/woods/HeroWoods";
import WoodsLogo from "../assets/images/woods-logo.avif";
import "../styles/WoodsSite.css";
import AboutWoods1 from "../components/woods/AboutWoods1";
import ApprovedBanks from "../components/ApprovedBanks";
import ConstructionProgressWoods from "../components/woods/ConstructionProgressWoods";
import GalleryWoods from "../components/woods/GalleryWoods";
import WoodsSpecificationAccordion from "../components/woods/WoodsSpecificationAccordion";
import ContactWoods from "../components/woods/ContactWoods";
import Clubhouse from "../components/woods/ClubHouseWoods";
import AboutWoods from "../components/woods/AboutWoods";
import WoodsMasterplan from "../components/woods/WoodsMasterplan";
import LocationWoods from "../components/woods/LocationWoods";

const menuLinks = [
  { label: "ABOUT WOODS", target: "about-serene" },
  { label: "AMENITIES", target: "woods-clubhouse" },
  { label: "MASTERPLAN", target: "woods-masterplay" },
  { label: "LOCATION", target: "woods-location" },
  { label: "SPECIFICATIONS", target: "serene-specifications" },
  { label: "CONTACT", target: "serene-contact" },
];

function WoodsSite() {
  return (
    <section id="home-woods">
      <HeaderSerene logo={WoodsLogo} menuLinks={menuLinks} />
      <HeroWoods />
      <AboutWoods />
      <AboutWoods1 />
      <Clubhouse />
      <WoodsMasterplan />
      <LocationWoods />
      {/* <GalleryWoods /> */}
      {/* <ConstructionProgressWoods /> */}


      <WoodsSpecificationAccordion />

      <ApprovedBanks />
      <ContactWoods />


    </section>
  );
}

export default WoodsSite;
